module.exports = __webpack_public_path__ + "img/arrow-down.827af067.svg";